import request from '@/utils/request.js'

//新闻列表
export const getNewsList = (data) => {
	return request({
		url: '/art/Article/GetArticle',
		method: 'post',
		data: data,
	})
}

// 新闻列表详情
export const getNewsDeail = (data) => {

	return request({
		url: '/art/Article/GetArticleById',
		method: 'post',
		data: data,
	})
}

// 留言板提交
export const sumbitRecommend = (data) => {

	return request({
		url: '/art/Article/AddRecommendationInfo',
		method: 'post',
		data: data,
	})
}

//首页动态数据获取
export const getHomeDynamicList = (data) => {
	return request({
		url: '/art/WebSiteHome/GetHomeData',
		method: 'post',
		data: data,
	})
}

//联系我们
export const getContactUsList = (data) => {
	return request({
		url: '/art/WebSiteHome/GetCompnayData',
		method: 'post',
		data: data,
	})
}

//人才战略
export const getTalentList = (data) => {
	return request({
		url: '/art/WebSiteHome/GetRecruitment',
		method: 'post',
		data: data,
	})

}


//项目案例
export const getProjectCasesList = (data) => {
	return request({
		url: '/art/WebSiteHome/GetPorjectCase',
		method: 'post',
		data: data,
	})
}

//产品中心
export const getProductCenterList = (data) => {
	return request({
		url: '/art/WebSiteHome/GetProductCategory',
		method: 'post',
		data: data,
	})
}